import Config from '../Models/Config';
import Data from '../States/Data';
import Helper from '../Models/Helper';
import Session from '../States/Session';
import Scripture from '../Models/Scripture';
import Slider from './Slider';
import {get, writable} from 'svelte/store';

const storage = {previous: ''};
const router = writable(storage);

async function URI(url, state, silent) {
	const uri = decodeURI(url);

	const slider = match => {
		const type = match[1];
		let resolved = false;
		if (Helper.type(Slider[type], 'function')) try {
			const data = state ? (state.data || []) : [];
			Slider.history(type, data);
			resolved = true;
		}
		catch (error) {
			Slider.start();
			console.error('Slider State Error', error);
			resolved = false;
		}

		return resolved;
	};

	const start = match => {
		Slider.start();
		return true;
	};

	const privacy = match => {
		Slider.privacy();
		return true;
	};

	const verify = match => {
		Slider.verify(match[1]);
		return true;
	};

	const verifyPassword = match => {
		Slider.verifyPassword(match[1]);
		return true;
	};

	const testament = match => {
		Slider.testament(match[1] + match[2]);
		return true;
	};

	const chapter = async match => {
		const book = await Scripture.bookCodeByName(match[1]);
		if (book) {
			const chapter = `${book}_${match[2]}`;
			Slider.chapter(chapter);
			return true;
		}
	};

	const popup = match => {
		return true;
	};

	const all = async match => {
		const book = await Scripture.bookCodeByName(match[1]);
		if (book) {
			Slider.chapters(book);
			return true;
		}
	};

	const routing = [
		['^/state/([^/]+)', slider],
		['^/start$', start],
		['^/privacy$', privacy],
		['^/*$', start],
		['^/verify/([^/]+)', verify],
		['^/password/verify/([^/]+)', verifyPassword],
		['^/(o)ude-(t)estament$', testament],
		['^/(n)ieuwe-(t)estament$', testament],
		['^/boek/([^/]+)/([0-9]+)', chapter],
		['^/bible/BasicBible/([^/]+)/([0-9]+)', chapter],
		['^/([^/]+)/([0-9]+)', chapter],
		['^/([^/]+)$', all]
	];

	let valid = false;
	for (const item of routing) {
		const expression = new RegExp(item[0], 'i');
		const match = uri.match(expression);
		if (match) {
			valid = await item[1](match);
			if (valid) break;
		}
	}

	if (!silent && valid) router.push(uri);
	else if (!valid) {
		if (Helper.app()) Slider.start();
		else Slider.missing();
	}
}

function history() {
	window.addEventListener('popstate', event => {
		const uri = Helper.undefined(event.state.uri) ? '' : event.state.uri;
		if (uri) {
			URI(uri, event.state, true);
			const hash = JSON.stringify(event.state);
			storage.previous = hash;
			router.set(storage);
		}
	});
}

function click() {
	jQuery('body').on('click', 'a[href]', function(event) {
		const current = window.location;
		const uri = jQuery(this).attr('href');
		const url = new URL(uri, current.href);
		if (url.host == current.host) {
			Helper.prevent(event);
			URI(uri);
		}
	});
}

router.init = async () => {
	const uri = window.location.pathname;
	await URI(uri);
	history();
	click();
};

router.back = () => {
	window.history.back();
}

router.push = state => {
	if (Helper.type(state, 'string'))
		state = {uri: state};

	const hash = JSON.stringify(state);
	if (storage.previous != hash) {
		storage.previous = hash;

		Helper.canonical();
		const path = window.location.pathname;
		const url = Helper.app() ? path : state.uri;
		window.history.pushState(state, '', url);
		router.set(storage);

		let session = true;
		if (!Helper.undefined(state.session))
			session = !!state.session;

		if (session)
			Session.updateRouter(url);
	}
};

export default router;